import repository from "@/plugins/axios/secureClient";

const resource = "/history-actions";

export default {
  getHistory(params) {
    return repository.get(`${resource}`, { params });
  },

  getHistoryDetails(itemHistoryId) {
    return repository.get(`${resource}/details/${itemHistoryId}`);
  },

  getObjectDetails(scopeName, itemObjectId) {
    return repository.get(
      `${resource}/object/${scopeName}/${itemObjectId}/details`
    );
  },

  getObjectHistory(actionPage, recordId, params) {
    return repository.get(`${resource}/object/${actionPage}/${recordId}`, {
      params
    });
  }
};
